import {HTTP_METHODS} from '../httpMethods'

const UNSAFE_SEGMENT_PATTERN = /(\.\.|\/|\\|%2f|%5c|%2e%2e)/i

const toQueryString = queryParams => {
  if (!queryParams) {
    return ''
  }

  const raw = typeof queryParams === 'string' ? queryParams.replace(/^[?&]+/, '') : queryParams
  return new URLSearchParams(raw).toString()
}

const withQuery = (path, queryParams) => {
  const queryString = toQueryString(queryParams)
  return queryString ? `${path}?${queryString}` : path
}

const toSafePathSegment = value => {
  const raw = String(value ?? '').trim()

  if (!raw || UNSAFE_SEGMENT_PATTERN.test(raw)) {
    throw new Error(`Unsafe path segment: ${raw}`)
  }

  return encodeURIComponent(raw)
}

export const PRODUCTS_CONFIG = {
  PRODUCT_LIST: queryParams => ({
    endPoint: withQuery('product', queryParams),
    // mockData: ProductListData,
    baseUrlKey: 'inventoryApiUrl',
    method: HTTP_METHODS.POST,
  }),

  PRODUCT_CSV_DOWNLOAD: queryParams => ({
    endPoint: withQuery('product/download', queryParams),
    method: HTTP_METHODS.POST,
    baseUrlKey: 'inventoryApiUrl', // Dynamically use INVENTORY_API_URL
  }),

  PRODUCT_ENRICHMENT_TEMPLATE_DOWNLOAD: queryParams => ({
    endPoint: withQuery('product/enrichment/download', queryParams),
    method: HTTP_METHODS.GET,
    baseUrlKey: 'inventoryApiUrl',
    headers: {
      scope: 'pepsi',
    },
  }),

  UPDATE_PRODUCT: {
    endPoint: 'product',
    method: HTTP_METHODS.PUT,
    baseUrlKey: 'inventoryApiUrl',
  },

  UPLOAD_PRODUCT_MEDIA: productId => ({
    endPoint: `product/${toSafePathSegment(productId)}/image/upload`,
    method: HTTP_METHODS.POST,
    baseUrlKey: 'inventoryApiUrl',
    headers: {
      scope: 'pepsi',
    },
  }),

  BULK_EDIT_PRODUCTS: (extraHeaders = {}) => ({
    endPoint: 'product/bulk',
    method: HTTP_METHODS.PATCH,
    baseUrlKey: 'inventoryApiUrl',
    headers: {
      scope: 'pepsi',
      ...extraHeaders,
    },
  }),
}
